import React, { useEffect, useState } from 'react';
import AnimatedLoader from '../../../components/AnimatedLoader';
import useMoengage from '../../../hooks/useMoengage';
import '../../../styles/components/MyJobListingForRejectedCandidates/MyJobListingForRejectedCandidates.scss';
import AppConstants from '../../../constants/AppConstants';
import zomatoLogo from '../../../assets/zomato.png';
import uberLogo from '../../../assets/uber.png';
import defaultCompanyIcon from '../../../assets/defaultCompany.svg';
import swiggyLogo from '../../../assets/swiggy.png';
import porterLogo from '../../../assets/porter.jpeg';
import shadowfaxLogo from '../../../assets/shadowfax.png';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { func } from 'prop-types';

import { ConstructionRounded } from '@mui/icons-material';
import MyJobListingForRejectedCandidatesCard from './MyJobListingForRejectedCandidatesCard';

function MyJobListingForRejectedCandidates() {
    const [userId, setUserId] = useState('');
    const [myJobs, setMyJobs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('No jobs available!');
    const [open, setOpen] = React.useState(false);
    const [createMoengageUser, trackEvent] = useMoengage();



    const notify = ()=>{
     toast('Your job application is submitted',
        {position: toast.POSITION.TOP_CENTER})
        setOpen(true);
    }
    const getMyJobsList = async id => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_HOST}/job-applications/notAppliedJobs/${id}`
            );
            const resData = await response.json();
            //response
            console.log("Response-> ",resData);
            if(response.status==200){
                //const resData = await response.json();
                if(resData.jobsResponse.length!=0){
                    console.log("Create Moengage User Created",resData.jobsResponse[0].mitraBackendUserId,resData.jobsResponse[0].name,resData.jobsResponse[0].phoneNumber)
                    createMoengageUser(resData.jobsResponse[0].mitraBackendUserId, resData.jobsResponse[0].name, resData.jobsResponse[0].phoneNumber);
                }
                setMyJobs(resData.jobsResponse);
                setIsLoading(false);
            }
            else if(response.status==400){
                const resData = await response.json();
                setError(resData.message);
            }
            else{
                throw new Error();
            }
            }
             catch (err) {
                setError('Service Unavailable!');
            }

        setIsLoading(false);
    };

    function selectCompany(companyName){
        if(companyName.toLowerCase()=='shadowfax'){
            return shadowfaxLogo;
        }else if(companyName.toLowerCase()=='zomato'){
            return zomatoLogo;
        }
        else if(companyName.toLowerCase()=='uber_3pl'){
            return uberLogo;
        }
        else if(companyName.toLowerCase()=='swiggy'){
            return swiggyLogo;
        }
        else if(companyName.toLowerCase()=='porter'){
            return porterLogo;
        }
        return defaultCompanyIcon;
    }


    const handleClick = async (post,idx) => {
        if(post.isApplied) {
            return;
        }

        var data = JSON.stringify({
          "jobId": post.jobId,
          "jobDemandId":post.jobDemandId,
          "companyName": post.companyName,
          "sourceName": post.source,
          "sourceId":post.sourceId,
          "jobLocation":post.jobCity,
          "userId":userId
        });

        console.log("data : ",data);
        var config = {
          method: 'post',
          url: `${process.env.REACT_APP_API_HOST}/job-applications/createApplication`,
          headers: { 
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials':'true',
            'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
            'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
            "Cache-Control": null,
            "X-Requested-With": null

          },
          data : data
        };
        
        axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
        
        post.isApplied = true;
        notify();
        
        trackEvent('alt_job_applied', {
            company: post.companyName,
          });
        setMyJobs([...myJobs.slice(0, idx), {...myJobs[idx], isApplied: true},...myJobs.slice(idx + 1)]);
        return;
    }

    useEffect(() => {
        toast.configure()
        const paramString = window.location.href.split('?')[1];
        const queryString = new URLSearchParams(paramString);
        let userIdParam;
        queryString.forEach((value, key) => {
            if (key === 'userId') userIdParam = value;
        });


        if (!userIdParam) {
            setIsLoading(false);
            setError('No details available');
        } else {
            setUserId(userIdParam);
            getMyJobsList(userIdParam);
        }
    }, []);

    return isLoading ? (
        <AnimatedLoader />
    ) : (
            <div className="my_jobs_listing" style={{minHeight:'100vh'}}>
                <div className="job_container" style={{minHeight:'100vh'}}>
                    <p style={{paddingInlineStart: '5%',paddingTop:'10%'}}><b>Jobs for you</b> </p>
                    <ul style={{paddingInlineStart: '5%',paddingTop: '5%',}}>
                        {myJobs.length <= 0 && <h2>{error}</h2>}
                        {myJobs.map((post, i) =>{
                            return <MyJobListingForRejectedCandidatesCard post={post} key={i + post.jobId} selectCompany={selectCompany} handleClick={handleClick} idx={i}  userId={userId} />;
                        })}
                    
                    </ul>

                </div>
               
            </div>
    );

}

export default MyJobListingForRejectedCandidates;